import { useEffect, useRef, useState } from "react";
import * as yup from "yup";

import { View } from "./View";
import {
  useApiErrors,
  useAuth,
  useCounter,
  useHookForm,
  useMerchantApiMutation,
  useQueryString,
} from "../../hooks";
import {
  IConfirmEmailRequest,
  IResendConfirmationEmailRequest,
} from "../../interfaces-and-types";
import { getApiErrorsByFieldName, globalHandlerUtils } from "../../utils";
import { useNavigate } from "react-router-dom";
import { accountConfirmationConstants } from "../../constants";

export interface IConfirmEmailViewProps {
  email: string;
  isLoadingConfirmEmail: boolean;
  isErrorConfirmEmail: boolean;
  emailConfirmationSuccessful: boolean;
  redirectToLoginCountdown: number;
  resendEmailConfirmationLink: () => void;
  errorMessage: string;
}

export const ConfirmEmail = () => {
  const navigate = useNavigate();

  // get the form values from the url
  console.log(
    "accountConfirmationConstants.emailQueryStringName",
    accountConfirmationConstants.emailQueryStringName
  );
  console.log(
    "accountConfirmationConstants.confirmationCodeQueryStringName",
    accountConfirmationConstants.confirmationCodeQueryStringName
  );
  console.log(
    "accountConfirmationConstants.merchantIdQueryStringName",
    accountConfirmationConstants.merchantIdQueryStringName
  );

  const query = useQueryString();
  const emailQueryString = query.get(
    accountConfirmationConstants.emailQueryStringName
  );
  const codeQueryString = query.get(
    accountConfirmationConstants.confirmationCodeQueryStringName
  );
  const merchantIdQueryString = query.get(
    accountConfirmationConstants.merchantIdQueryStringName
  );

  const {
    isLoading: isLoadingConfirmEmail,
    isSuccess: isSuccessConfirmEmail,
    isError: isErrorConfirmEmail,
    // data: apiResponse,
    mutate: confirmEmail,
  } = useMerchantApiMutation<IConfirmEmailRequest, void>(
    "confirmEmail"
  ).usePostMutation;

  const {
    // isLoading: isLoadingResendConfirmationEmail,
    // isSuccess: isSuccessResendConfirmationEmail,
    mutate: resendConfirmationEmail,
  } = useMerchantApiMutation<IResendConfirmationEmailRequest, null>(
    "resendConfirmationEmail"
  ).usePostMutation;

  const resendEmailConfirmationLink = () =>
    emailQueryString && resendConfirmationEmail({ email: emailQueryString });

  const { apiErrors } = useApiErrors();

  const redirectToLoginCountdown = useCounter({
    isActive: isSuccessConfirmEmail,
    initialStartCount: 5,
    stopValue: 0,
    countDirection: "DOWN",
  });

  useEffect(() => {
    if (redirectToLoginCountdown === 0) navigate("/login");
  }, [redirectToLoginCountdown]);

  let timeoutIdConfirmEmail = useRef<NodeJS.Timeout>();

  useEffect(() => {
    console.log("emailQueryString: ", emailQueryString);
    console.log("codeQueryString: ", codeQueryString);
    console.log("merchantIdQueryString: ", merchantIdQueryString);

    const allQueryStringValuesRetrieved =
      !!emailQueryString && !!codeQueryString && !!merchantIdQueryString;

    console.log(
      "allQueryStringValuesRetrieved: ",
      allQueryStringValuesRetrieved
    );
    console.log("");
    console.log("");
    console.log("------------------------------------------------");

    if (allQueryStringValuesRetrieved) {
      timeoutIdConfirmEmail.current = setTimeout(
        () =>
          confirmEmail({
            account_id: merchantIdQueryString,
            email: emailQueryString,
            code: codeQueryString,
          }),
        1000
      );
    }

    return () =>
      timeoutIdConfirmEmail && clearTimeout(timeoutIdConfirmEmail.current);
  }, [emailQueryString, codeQueryString, merchantIdQueryString]);

  const errorMessage =
    getApiErrorsByFieldName(
      accountConfirmationConstants.emailQueryStringName,
      apiErrors
    ) ||
    getApiErrorsByFieldName(
      accountConfirmationConstants.confirmationCodeQueryStringName,
      apiErrors
    ) ||
    getApiErrorsByFieldName(
      accountConfirmationConstants.merchantIdQueryStringName,
      apiErrors
    ) ||
    "";

  return (
    <View
      email={emailQueryString || ""}
      isLoadingConfirmEmail={isLoadingConfirmEmail}
      isErrorConfirmEmail={isErrorConfirmEmail}
      emailConfirmationSuccessful={isSuccessConfirmEmail}
      redirectToLoginCountdown={redirectToLoginCountdown}
      resendEmailConfirmationLink={resendEmailConfirmationLink}
      errorMessage={errorMessage}
    />
  );
};
